(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Money"] && !Shopify.designMode) return;
  try {
    
  // Ensure video plays on mobile (some browsers block autoplay)
  document.addEventListener('DOMContentLoaded', function() {
    const videos = document.querySelectorAll('.vd-video-{{ section.id }}');
    videos.forEach(function(video) {
      video.play().catch(function(error) {
        // Autoplay was prevented, add click to play
        video.closest('.vd-video-wrapper-{{ section.id }}').addEventListener('click', function() {
          video.play();
        }, { once: true });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
